import { render, staticRenderFns } from "./ModelChooser.vue?vue&type=template&id=5362110e&"
import script from "./ModelChooser.vue?vue&type=script&lang=js&"
export * from "./ModelChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports